import React, { useContext } from 'react'
import { PackageIcon, SignOutIcon, TreePalmIcon,  UserGearIcon } from '@phosphor-icons/react'
import { Menu, MenuButton, MenuItem, MenuItems } from '@headlessui/react'
import { Link } from 'gatsby'
import UserBadge from '@components/UserAccount/UserBadge'
import UserContext from '@context/UserContext'

// assets
import imgCaretFill from '@images/icons/caret-up-fill.svg'
import UserAccountSidebar from '@components/UserAccount/UserAccountSideBar'

const UserAccountMenu = () => {

    const getUserInitials = (firstName = "W", lastName = "W") => {
        if (!firstName || !lastName) return "";
        return `${firstName.charAt(0)}${lastName.charAt(0)}`.toUpperCase();
    };
	
	const {user, menuButtonRef, closeAccountMenu, handleSignOut } = useContext(UserContext)

	return (
		<Menu as="div" className={'relative'} >
			{(open, close) => (<>
				<MenuButton ref={menuButtonRef} className='inline-flex items-center rounded-full gap-x-1'>
                    {user ? 
						<div 
							className="rounded-full w-6 h-6 p-0.5 bg-primary text-white flex items-center justify-center text-[clamp(10px,4vw,12px)]" 
							role="none"
						>
							{getUserInitials(user?.firstName, user?.lastName)}
						</div> : null
                    }
					<img src={imgCaretFill} className={`m-0 ${!open ? 'rotate-0' : 'rotate-180'}`} alt="caret" />
				</MenuButton>	

				
				<MenuItems
					transition
					anchor="bottom end"
					className="w-screen md:w-64 p-4 origin-top-right mt-4 md:mt-6 md:rounded-xl bg-white shadow-md transition duration-100 ease-out [--anchor-gap:var(--spacing-1)] focus:outline-none data-[closed]:scale-95 data-[closed]:opacity-0 z-[52]"
				>
					<div className='hidden md:block'>
						<UserBadge data={user} compact />

						<div className='flex flex-col border-t border-b border-[#E5E5E5] my-2 py-2 gap-y-2'>
							<MenuItem>
								<Link 
									to="/user-account/order-history" 
									className="inline-flex gap-x-2 items-center p-1 w-full hover:bg-black hover:text-white text-md lg:text-sm"
								>
									<PackageIcon size={16} weight="light" />
									Order Details
								</Link>
							</MenuItem>
                            
                            <MenuItem>
                                <Link 
                                    to="/user-account/blackbough-beach-club" 
                                    className="inline-flex gap-x-2 items-center p-1 w-full hover:bg-black hover:text-white text-md lg:text-sm"
                                >
                                    <TreePalmIcon size={16} weight="light" />
                                    Blackbough Beach Club
                                </Link>
                            </MenuItem>
                            
							<MenuItem>
								<Link 
									to="/user-account/personal-information" 
									className="inline-flex gap-x-2 items-center p-1 w-full hover:bg-black hover:text-white text-md lg:text-sm"
								>
									<UserGearIcon size={16} weight="light" />
									Account Setting
								</Link>
							</MenuItem>
						</div>
						<MenuItem>
							<button 
								className="inline-flex gap-x-2 items-center p-1 w-full text-[#B91C1C] hover:bg-[#FEE2E2]"
								onClick={() => {
									handleSignOut()
									closeAccountMenu()
								}}
							>
								<SignOutIcon size={16} weight="light" />
								Sign Out
							</button>
						</MenuItem>
					</div>

					<div className='block md:hidden'>
						<p className='pt-6 text-[20px] text-center w-full'>My Account</p>
						<UserAccountSidebar 
							className='h-full w-full flex flex-col space-y-6 pb-8'
						/>
					</div>
				</MenuItems>
			</>)}
		</Menu>
	)
}

export default UserAccountMenu